import { Box, type ChakraProps, Flex, Heading, Img, Text, type TextProps, useMediaQuery } from "@chakra-ui/react"
import { FALLBACKIMAGES, mobileBreakpoint } from "../../common/commonConstants"
import { Colors } from "../../theme/colors"
import { InfinityWrapper } from "./inifinity-wrapper"

interface BannerType1Props {
  heading?: string
  heading1?: string
  subHeading?: string
  subText1?: string
  subText2?: string
  image: string | null | undefined
  subText2Styles?: TextProps
  wrapperStyles?: ChakraProps
  imageStyles?: ChakraProps
}
export const BannerType1 = ({
  heading,
  heading1,
  subHeading,
  subText1,
  subText2,
  image,
  subText2Styles,
  wrapperStyles,
  imageStyles
}: BannerType1Props): JSX.Element => {
  const fallBackImage = FALLBACKIMAGES["250x250"]
  const height = "322px"

  const [isDesktop] = useMediaQuery(`(min-width: ${mobileBreakpoint}px)`)

  return (
    <InfinityWrapper height={["auto", "auto", "auto", height]} bg={Colors.Secondary.c2_100} inputStyles={{ ...wrapperStyles }}>
      {/* <Img display={['block']} margin="auto" mb="6" h={['192px', '192px', '192px']} w="fit-content" src={image ?? fallBackImage} alt="banner" /> */}
      <Flex pt={["32px"]} flexDir={"column"} pb="0" px={[4, 4, 4, 0, 0, 0]} alignContent={["center", "left", "left", "left", "left", "left"]}>
        <Flex justify={"space-between"} w="100%">
          {heading && isDesktop && (
            <Heading variant="Heading1" mb="20px" textAlign={["center", "center", "center", "initial", "initial", "initial"]}>
              {heading}
              {heading1 && <Text>{heading1}</Text>}
            </Heading>
          )}
          <Img
            display={["block", "block", "block", "none", "none", "none"]}
            margin="auto"
            mb="6"
            h={["192px", "192px", "192px"]}
            w="fit-content"
            src={image ?? fallBackImage}
            alt="banner"
          />
        </Flex>
        {heading && !isDesktop && (
          <Box alignContent={"center"}>
            <Heading
              variant="RHeading1"
              mb="20px"
              fontSize={["40px", "40px", "40px", "60px", "60px", "60px"]}
              textAlign={["center", "center", "center", "initial", "initial", "initial"]}
            >
              {heading}
              {heading1 && (
                <Heading variant="RHeading1" fontSize={["40px", "40px", "40px", "60px", "60px", "60px"]}>
                  {heading1}
                </Heading>
              )}
            </Heading>
          </Box>
        )}
        <Flex
          w={["100%", "100%", "100%", "620px"]}
          height="100%"
          flexDir={"column"}
          maxW="440px"
          textAlign={["center", "center", "center", "initial", "initial", "initial"]}
        >
          {subHeading && (
            <Heading color="accent" my="0" variant="RHeading3CAPS">
              {subHeading}
            </Heading>
          )}
          <Box flexDir={"column"} height="100%" mb="5px" textAlign={["justify", "justify", "justify", "initial", "initial", "initial"]}>
            {subText1 && (
              <Text variant={"RBodyBold"} fontWeight={"bold"} mt="14px">
                {subText1}
              </Text>
            )}
            {subText2 && (
              <Text mt="10px" variant={"RBody"} {...subText2Styles}>
                {subText2}
              </Text>
            )}
          </Box>
        </Flex>
      </Flex>

      <Box
        display={["none", "none", "none", "block", "block", "block"]}
        alignSelf={"center"}
        w="265px"
        ml="10px"
        background={`url(${image ?? fallBackImage}) no-repeat 50% 50%`}
        backgroundSize={"contain"}
        {...imageStyles}
      ></Box>
    </InfinityWrapper>
  )
}
